import { ageRestrictions } from 'shared/constants';

export function getAgeRestriction(geoInfo) {
  const { country, region } = geoInfo || {};
  if (!ageRestrictions[country]) {
    return ageRestrictions.default;
  }
  if (!ageRestrictions[country][region]) {
    return ageRestrictions[country].default;
  }
  return ageRestrictions[country][region];
}
